import { render, staticRenderFns } from "./StaffGrid.vue?vue&type=template&id=69bfcb94&scoped=true&"
import script from "./StaffGrid.vue?vue&type=script&lang=js&"
export * from "./StaffGrid.vue?vue&type=script&lang=js&"
import style0 from "./StaffGrid.vue?vue&type=style&index=0&id=69bfcb94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bfcb94",
  null
  
)

export default component.exports